import fairHousing from "./fair_housing.svg";

export { fairHousing };
